import script from "./SolutionReplay.vue?vue&type=script&setup=true&lang=js"
export * from "./SolutionReplay.vue?vue&type=script&setup=true&lang=js"

import "./SolutionReplay.vue?vue&type=style&index=0&id=8290e036&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8290e036"]])

export default __exports__